import React from 'react';

import { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';

import { AiExperienceName, DEFAULT_GAS_CHANNEL } from '../../../../constants';
import { ConfluenceResultCard } from './confluence/ConfluenceResultCard';
import type { NavigationalCardProps } from './types';

export const NavigationalCard = (props: NavigationalCardProps): React.JSX.Element => (
	<AIEventsInstrumentationProvider
		config={{
			product: props.searchResultData?.product || '',
			subproduct: props.subproduct ?? 'unknown',
			aiFeatureName: 'smartAnswers',
			aiExperienceName: AiExperienceName.NAVIGATIONAL_SEARCH_RESULT_CARD,
			// TODO: update this section once we have agreement on how we track this card towards SAIN
			proactiveGeneratedAI: 0,
			userGeneratedAI: 0,
			isAIFeature: 0,
			source: props.source,
			channel: DEFAULT_GAS_CHANNEL,
		}}
	>
		{/* breakout into different product types here based on typename from searchResultData */}
		{props.searchResultData?.__typename === 'SearchConfluencePageBlogAttachment' ? (
			<ConfluenceResultCard {...props} />
		) : null}
	</AIEventsInstrumentationProvider>
);
